<template>
    <body class="bg-white" id="navigater-header">
        <div class="" id="app">
            <header class="flex justify-between items-center py-8  sticky top-0 z-40">
                <div class="flex items-center py-3 px-20 sm:px-6 lg:px-20">
                    <img alt="Glowe logo" class="w-10 h-10 rounded-full mr-2" src="@/assets/logo.png" width="100"
                         height="100" />
                    <span class="text-3xl font-bold">识心智能</span>
                </div>

                <div class="flex  font-bold ml-32 h-full">
                    <div class=" px-4  hover:text-primary">
                        <a @click="goHome()">首页</a>
                    </div>
                    <div class=" px-4  hover:text-primary">
                        <a @click="goHome()">产品应用场景</a>
                    </div>
                    <div class="relative  px-4  hover:text-primary "
                         @mouseover="showMenu = true"
                         @mouseleave="showMenu = false">
                        <a>产品体系  <i class="fa fa-chevron-down" style="font-size:14px"></i></a>
                        <div v-if="showMenu"
                             @mouseenter="showMenu = true"
                             @mouseleave="showMenu = false"
                             class="absolute left-0  bg-white border border-gray-300 rounded shadow-lg  left-1/2 transform -translate-x-1/2 z-50">
                            <ul class="p-0 m-0 text-black w-80 ">
                                <li class="h-12   hover:text-primary border-b border-gray-300 flex items-center justify-center">
                                    <a class="block text-center">杏坛识心坊 |校园智慧心理系统</a>
                                </li>
                                <li class="h-12 hover:text-primary flex items-center justify-center">
                                    <a class="block  text-center" @click.prevent="gotoCounselorAI">咨询师专业进化伙伴 |心理咨询AI协同系统</a>
                                    <div class="px-1 absolute bottom-0 right-0 text-xs bg-gray-300 font-medium ">Beta</div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class=" px-4 hover:text-primary">
                        <a @click.prevent="gotoNewsInfo">识心动态</a>
                    </div>
                    <div class=" px-4  hover:text-primary">
                        <a @click="goHome()">关于我们</a>
                    </div>
                </div>
                <div class="mr-16">
                    <div v-if="isLoggedIn()" class="relative">
                        <img alt="User avatar" class="w-10 h-10 rounded-full cursor-pointer" height="40"
                             src="@/assets/user.png" width="40" @mouseover="showUserMenu" />
                        <div @mouseleave="hideUserMenu"
                             class="absolute right-0 mt-2 w-48 bg-white border border-gray-200 rounded-lg shadow-lg"
                             v-show="isUserMenuVisible">
                            <a class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100" href="#">
                                {{ user.nickname }}
                            </a>
                            <a class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100" href="#">
                                {{ user.phone }}
                            </a>
                            <a class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100" href="#" @click="logout">
                                退出登录
                            </a>
                        </div>
                    </div>
                    <div v-else class="flex items-center  py-3 px-4 sm:px-6 lg:px-8">
                        <button @click="showLogin"
                                class="bg-white text-primary border border-primary px-4 py-2 rounded-full mr-4 hover:bg-primary hover:text-white transition duration-300">
                            登录
                        </button>
                        <button @click="showRegister"
                                class="bg-primary text-white px-4 py-2 rounded-full hover:bg-primary-dark transition duration-300">
                            注册
                        </button>
                    </div>
                </div>
            </header>
            <main class="mainbody w-full">
                <div class="relative block  ">
                    <img src="@/assets/boot0.webp" alt="背景图片" class="z-0"/>
                    <img  src="@/assets/boot_purchase.webp"  
                         style="top: 245px;"
                         @click="handleClick"                          
                         class="absolute   w-32 h-12  left-60                         
                         cursor-pointer hover:opacity-80
                         rounded hover:bg-blue-100" />                     
                </div>
                
                <div class="boot1 m-0 p-0 block">
                    <img src="@/assets/boot1.webp" />
                </div>
                <div class="boot2">
                    <img src="@/assets/boot2.webp" />
                </div>
                <div class="boot3">
                    <img src="@/assets/boot3.webp" />
                </div>
                <div class="boot4">
                    <img src="@/assets/boot4.webp" />
                </div>
                <div class="boot5">
                    <img src="@/assets/boot5.webp" />
                </div>
            </main>
        </div>
    </body>
</template>
<script>
import axios from 'axios';
import { jwtDecode } from 'jwt-decode';

export default {
    name: 'HomePage',
    metaInfo: {
        title: '识心智能 - 教师',
        meta: [
            {
                name: 'description',
                content: '识心智能官网，各行各业量身定制专属的智能心理健康解决方案，以AI科技的力量促进心理健康事业的创新与繁荣发展'
            },
            {
                name: 'keywords',
                content: '识心智能, 心理健康, 心理健康AI, 心理AI, 健康AI, 心理健康方案, 声音疗愈, 智慧校园, 校园心理, 咨询师AI助手'
            }
        ]
    },

    data() {
        return {
            isLoggedInState: false,
            isUserMenuVisible: false,
            user: {},
            form: {
                dialogFormVisible: false,
                phone: '',
                phonePrefix: '+86',
                verificationCode: '',
                nickname: '',
                birthday: '',
                gender: '',
                invitationCode: '',
                agreement: false,
                phoneError: '',
                verificationCodeError: '',
                nicknameError: '',
                agreementError: '',
                isCountingDown: false,
                countdown: 60,
                verificationButtonText: '获取验证码'
            },
            loginForm: {
                dialogFormVisible: false,
                phonePrefix: '+86',
                phone: '',
                verificationCode: '',
                phoneError: '',
                verificationCodeError: '',
                isCountingDown: false,
                countdown: 60,
                verificationButtonText: '获取验证码'
            },
            registrationMessage: '',
            loginMessage: '',
            dialogWidth: '30%',
            showMenu: false, // 控制导航选项的显示状态
        };
    },
    mounted() {
        this.updateDialogWidth();
        window.addEventListener('resize', this.updateDialogWidth);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.updateDialogWidth);
    },
        methods: {
        handleClick() {
            alert("xxx")
        },
        scrollToSection(sectionId) {
            this.$router.scrollTo({
                el: `#${sectionId}`,
                behavior: 'smooth'
            });
        },
        updateDialogWidth() {
            if (window.innerWidth <= 1000) {
                this.dialogWidth = '90%';
            } else {
                this.dialogWidth = '30%';
            }
        },
        isLoggedIn() {
            return !!localStorage.getItem('token');
        },
        showUserMenu() {
            this.isUserMenuVisible = true;
        },
        hideUserMenu() {
            this.isUserMenuVisible = false;
        },
        gotoNewsInfo() {
            this.$router.push({ name: 'NewsInfo' });
        },
        gotoCounselorAI() {
            this.$router.push({ name: 'CounselorAI' });
        },
        showRegister() {
            this.loginForm.dialogFormVisible = false;
            this.form.dialogFormVisible = true;
        },
        showLogin() {
            this.form.dialogFormVisible = false;
            this.loginForm.dialogFormVisible = true;
        },
        beginTrial() {
            if (this.isLoggedIn()) {
                // 登录成功后路由到 /chat1 页面
                this.$router.push({ name: 'ChatOne' });
            } else {
                this.form.dialogFormVisible = false;
                this.loginForm.dialogFormVisible = true;
            }
        },
        goHome() {
            this.$router.push({ name: 'HomePage' });
        },
        logout() {
            localStorage.removeItem('token');
            this.user = {};
            this.isLoggedInState = false;
            this.$message({
                message: '登出成功',
                type: 'success'
            });
        },
        validatePhone() {
            const phoneRegex = /^[0-9]{11}$/;
            if (!phoneRegex.test(this.form.phone)) {
                this.form.phoneError = '请输入有效的11位手机号';
            } else {
                this.form.phoneError = '';
            }
        },
        validateVerificationCode() {
            if (!this.form.verificationCode) {
                this.form.verificationCodeError = '验证码不能为空';
            } else if (!/^[0-9]{6}$/.test(this.form.verificationCode)) {
                this.form.verificationCodeError = '请输入6位数字验证码';
            } else {
                this.form.verificationCodeError = '';
            }
        },
        validateNickname() {
            if (!this.form.nickname) {
                this.form.nicknameError = '昵称不能为空';
            } else if (this.form.nickname.length > 20) {
                this.form.nicknameError = '昵称长度不能超过20个字符';
            } else {
                this.form.nicknameError = '';
            }
        },
        validateAgreement() {
            if (!this.form.agreement) {
                this.form.agreementError = '请阅读并同意用户协议和隐私政策';
            } else {
                this.form.agreementError = '';
            }
        },
        saveAuthData(response) {
            // 保存 token 和用户信息到 localStorage
            if (response.data.token) {
                localStorage.setItem('token', response.data.token);
            }
        },
        async submitForm() {
            this.validatePhone();
            this.validateVerificationCode();
            this.validateNickname();
            this.validateAgreement();

            if (this.form.phoneError || this.form.verificationCodeError || this.form.nicknameError || this.form.agreementError) {
                return;
            }

            try {
                const payload = {
                    phone: this.form.phone,
                    nickname: this.form.nickname,
                    birthday: this.form.birthday,
                    gender: this.form.gender,
                    verificationCode: this.form.verificationCode
                };
                const response = await axios.post('/api/register', payload, {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                });
                this.$message({
                    message: response.data.message,
                    type: response.data.type
                });
                this.registrationMessage = response.data.message;
                this.form.dialogFormVisible = false;
                if (response.data.token) {
                    this.saveAuthData(response);
                    // 查询用户信息
                    await this.checkTokenAndFetchUserInfo();
                }
            } catch (error) {
                console.error('Registration failed:', error);
                this.registrationMessage = 'Registration failed. Please try again.';
            }
        },
        validateLoginPhone() {
            const phoneRegex = /^[0-9]{11}$/;
            if (!phoneRegex.test(this.loginForm.phone)) {
                this.loginForm.phoneError = '请输入有效的11位手机号';
            } else {
                this.loginForm.phoneError = '';
            }
        },
        validateLoginVerificationCode() {
            if (!this.loginForm.verificationCode) {
                this.loginForm.verificationCodeError = '验证码不能为空';
            } else if (!/^[0-9]{6}$/.test(this.loginForm.verificationCode)) {
                this.loginForm.verificationCodeError = '请输入6位数字验证码';
            } else {
                this.loginForm.verificationCodeError = '';
            }
        },
        async submitLoginForm() {
            this.validateLoginPhone();
            this.validateLoginVerificationCode();

            if (this.loginForm.phoneError || this.loginForm.verificationCodeError) {
                return;
            }

            try {
                const payload = {
                    phone: this.loginForm.phone,
                    verificationCode: this.loginForm.verificationCode
                };
                const response = await axios.post('/api/login', payload, {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                });
                this.$message({
                    message: response.data.message,
                    type: response.data.type
                });
                console.log('Login successful:', response.data);
                this.loginMessage = response.data.message;
                this.loginForm.dialogFormVisible = false;
                if (response.data.token) {
                    this.saveAuthData(response);
                    // 查询用户信息
                    await this.checkTokenAndFetchUserInfo();
                }
            } catch (error) {
                console.error('Login failed:', error);
                this.loginMessage = 'Login failed. Please try again.';
            }
        },
        async getVerificationCode(formType) {
            const form = this[formType];
            this.validatePhone();
            if (form.phoneError) {
                this.$message({
                    message: form.phoneError,
                    type: 'error'
                });
                return;
            }

            try {
                const response = await axios.post('/api/get_verification_code', {
                    phone: form.phone,
                    type: formType === 'form' ? 'register' : 'login'
                }, {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                });
                console.log('Verification code sent:', response.data);
                this.$message({
                    message: response.data.message,
                    type: response.data.type
                });
                this.startCountdown(formType);
            } catch (error) {
                console.error('Failed to get verification code:', error);
                this.$message({
                    message: '获取验证码失败，请重试',
                    type: 'error'
                });
            }
        },
        startCountdown(formType) {
            const form = this[formType];
            form.isCountingDown = true;
            form.countdown = 60;
            form.verificationButtonText = `${form.countdown}s`;
            const interval = setInterval(() => {
                form.countdown -= 1;
                if (form.countdown > 0) {
                    form.verificationButtonText = `${form.countdown}s`;
                } else {
                    clearInterval(interval);
                    form.verificationButtonText = '获取验证码';
                    form.isCountingDown = false;
                }
            }, 1000);
        },
        async checkTokenAndFetchUserInfo() {
            const token = localStorage.getItem('token');
            if (token) {
                try {
                    const decodedToken = jwtDecode(token);
                    const currentTime = Date.now() / 1000; // 当前时间的秒数
                    // const expDate = new Date(decodedToken.exp * 1000).toLocaleString();
                    // const currentDate = new Date(currentTime * 1000).toLocaleString();
                    // console.log('Token decoded.exp:', expDate, 'currentTime:', currentDate);

                    if (decodedToken.exp > currentTime) {
                        // Token 未过期，查询用户信息
                        const response = await axios.get(`/api/users/${decodedToken.user_id}`, {
                            headers: {
                                'Authorization': `Bearer ${token}`
                            }
                        });
                        this.user = response.data;
                        this.isLoggedInState = true;
                    } else {
                        // Token 已过期，清除本地存储
                        localStorage.removeItem('token');
                    }
                } catch (error) {
                    console.error('Token 解析失败或用户信息查询失败:', error);
                    localStorage.removeItem('token');
                }
            }
        },
        async updateToken() {
            const token = localStorage.getItem('token');
            if (token) {
                try {
                    const response = await axios.post('/api/refresh_token', {}, {
                        headers: {
                            'Authorization': `Bearer ${token}`
                        }
                    });
                    const newToken = response.data.token;
                    localStorage.setItem('token', newToken);
                } catch (error) {
                    console.error('Failed to update token:', error);
                }
            }
        },
    },
    created() {
        this.checkTokenAndFetchUserInfo();
        this.updateToken();
        }
};
</script>

<style>
    @import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.3/css/all.min.css');
    @import url('https://fonts.googleapis.com/css2?family=Noto+Sans+SC:wght@400;500;700&display=swap');
    @import url('https://cdn.jsdelivr.net/npm/tailwindcss@2.2.19/dist/tailwind.min.css');

    ul {
        list-style: none; /* 去掉默认的列表样式 */
    }

    body {
        font-family: 'Noto Sans SC', sans-serif;
    }
</style>
